export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kuenstler02-mobile-de.f3653b03.png";